import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import './phonePreview.less';

class PhonePreview extends PureComponent {

  static propTypes = {
    url: PropTypes.string.isRequired,
    showDefaultScreen: PropTypes.bool,
    intl: PropTypes.object,
  };

  state = {
    isIframeLoading: false
  };

  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.reload !== nextProps.reload) {
      const iframEl = ReactDOM.findDOMNode(this.iframeRef.current);
      iframEl.setAttribute('src', iframEl.getAttribute('src'));
      this.setState({ isIframeLoading: true });
    }
  }

  onLoad = () => {
    this.setState({ isIframeLoading: false });
  };

  static getComputedUrl(url) {
    let computedUrl = new URL(`${url.trim()}`);
    computedUrl.searchParams.set('previewMode', 'true');
    return computedUrl.href;
  }

  render() {
    const { url, showDefaultScreen, intl, isLoading } = this.props;
    const { formatMessage } = intl;

    return (
      <React.Fragment>
        <i className="phone-preview" />
        {showDefaultScreen ?
          <div className="phone-preview-iframe-stub">
            {formatMessage({ id: 'businessProfile.registration.noFormText' })}
          </div>
          :
          <div className="phone-preview-iframe-container">
            <iframe
              onLoad={this.onLoad}
              ref={this.iframeRef}
              title="privew"
              id="phonePreview"
              src={PhonePreview.getComputedUrl(url)}
            />
            {isLoading || this.state.isIframeLoading ?
              <div className="phone-preview-loading-overlay">
                <div className="loader" key={0}>
                  <div className="ui active inverted inline">
                    <div className="ui loader" />
                  </div>
                </div>
              </div> : null
            }
          </div>
        }
      </React.Fragment>
    );
  }
}

export default injectIntl(PhonePreview);
